
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class SpecSheetItemsGrid extends Serenity.EntityGrid<SpecSheetItemsRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.SpecSheetItems'; }
        protected getDialogType() { return SpecSheetItemsDialog; }
        protected getIdProperty() { return SpecSheetItemsRow.idProperty; }
        protected getInsertPermission() { return SpecSheetItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SpecSheetItemsRow.localTextPrefix; }
        protected getService() { return SpecSheetItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });

        }

    }
}